import {
  CreateFormDialog,
  CreateFormCancelButton,
  CreateFormSubmitButton,
} from '../../../../shared/components/CreateFormDialog';
import { FormFooterAction } from '../../../../shared/components/FormActionsContext';
import React from 'react';
import { CheckCircle2, Mail, Zap } from '../../../../shared/assets/AppIcons';

import { Textarea } from '@/shared/ui/textarea';

export default function RequestAutomationDialog({
  open,
  onOpenChange,
  automation,
  notes,
  onNotesChange,
  onSubmit,
  submitted,
}) {
  return (
    <CreateFormDialog open={open} onOpenChange={onOpenChange} icon={Zap} title="Richiedi Automazione">
      {!submitted ? (
        <div className="mt-4 space-y-4">
          <div className="bg-[var(--warning-soft)] border border-[var(--warning-border)] rounded-lg p-4">
            {automation ? (
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[var(--warning-soft)] rounded-lg flex items-center justify-center">
                  <automation.icona className="text-[var(--warning-text)]" size={16} />
                </div>
                <div>
                  <p className="font-semibold text-[var(--text-primary)]">{automation.nome}</p>
                  <p className="text-xs text-[var(--text-secondary)]">{automation.costoStimato}</p>
                </div>
              </div>
            ) : null}
          </div>

          <div>
            <p className="text-sm text-[var(--text-secondary)] mb-3">
              Vuoi aggiungere delle note o richieste specifiche?{' '}
              <span className="text-[var(--text-secondary)]">(opzionale)</span>
            </p>
            <Textarea
              placeholder="Es: Vorrei integrare con il mio CRM..."
              value={notes}
              onChange={(event) => onNotesChange(event.target.value)}
              className="min-h-24 resize-none"
            />
          </div>

          <div className="bg-[var(--primary-soft)] border border-[var(--border-strong)] rounded-lg p-3">
            <div className="flex items-start gap-2">
              <Mail className="text-[var(--primary)] mt-0.5" size={16} />
              <div>
                <p className="text-sm font-medium text-[var(--primary)]">Simulazione locale</p>
                <p className="text-xs text-[var(--primary)]">
                  La richiesta viene mostrata solo in anteprima locale e non viene inviata a un backend reale.
                </p>
              </div>
            </div>
          </div>

          <FormFooterAction>
            <div className="form-footer-actions">
              <CreateFormCancelButton onClick={() => onOpenChange(false)} type="button">
                Annulla
              </CreateFormCancelButton>
              <CreateFormSubmitButton onClick={onSubmit} type="button">
                Invia Richiesta
              </CreateFormSubmitButton>
            </div>
          </FormFooterAction>
        </div>
      ) : (
        <div className="mt-4 py-8 text-center">
          <div className="w-16 h-16 bg-[var(--success-soft)] rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="text-[var(--success-text)]" size={32} />
          </div>
          <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-2">Richiesta Inviata!</h3>
          <p className="text-sm text-[var(--text-secondary)]">
            La richiesta e stata registrata solo nella demo locale del modulo.
          </p>
        </div>
      )}
    </CreateFormDialog>
  );
}
